<script>
    export let feedback;
</script>

<p>
    {feedback}
</p>

<style>
    p {
        padding: 20px 10px 0px 10px;
        font-size: 26px;
        text-align: center;
    }
</style>
